import { createSlice } from "@reduxjs/toolkit";
import { createThunkFromApi } from "store/utils";
import marketApi from "./marketApi";

export const getMarketLoggedInForm = createThunkFromApi(
  "convert/getMarketLoggedInForm",
  marketApi.getMarketLoggedInForm
);

export const getInvestmentMarketList = createThunkFromApi(
  "convert/getInvestmentMarketList",
  marketApi.getInvestmentMarketList
);

export const getInvestmentMarketWithAccountBrokerList = createThunkFromApi(
  "convert/getInvestmentMarketWithAccountBrokerList",
  marketApi.getInvestmentMarketWithAccountBrokerList
);

export const getSingleMarketLoggedInList = createThunkFromApi(
  "convert/getSingleMarketLoggedInList",
  marketApi.getSingleMarketLoggedInList
);

export const getInvestmentMarket = createThunkFromApi(
  "convert/getInvestmentMarket",
  marketApi.getInvestmentMarket
);

export const getInvestmentMarketWithAccountBroker = createThunkFromApi(
  "convert/getInvestmentMarketWithAccountBroker",
  marketApi.getInvestmentMarketWithAccountBroker
);

const initialState = {
  marketLoggedInForm: null,
  investmentMarketList: null,
  investmentMarketWithAccountBrokerList: null,
  investmentMarket: null,
  singleMarketLoggedInList: null,
};

export const marketSlice = createSlice({
  name: "market",
  initialState,

  extraReducers: {
    [getMarketLoggedInForm.fulfilled]: (state, { payload }) => {
      state.marketLoggedInForm = payload.data;
    },

    [getInvestmentMarketList.fulfilled]: (state, { payload }) => {
      state.investmentMarketList = payload.data;
    },

    [getInvestmentMarketWithAccountBrokerList.fulfilled]: (state, { payload }) => {
      state.investmentMarketWithAccountBrokerList = payload.data;
    },

    [getInvestmentMarket.fulfilled]: (state, { payload }) => {
      state.investmentMarket = payload.data;
    },

    [getInvestmentMarketWithAccountBroker.fulfilled]: (state, { payload }) => {
      state.investmentMarket = payload.data;
    },

    [getSingleMarketLoggedInList.fulfilled]: (state, { payload }) => {
      state.singleMarketLoggedInList = payload.data?.data?.[0] || [];
    },
  },
});

export default marketSlice.reducer;
